import { render, staticRenderFns } from "./UsermanagementList.vue?vue&type=template&id=b273767c"
import script from "./UsermanagementList.vue?vue&type=script&lang=js"
export * from "./UsermanagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports